<template>
    <div class="divider__line" v-bind:class="{ 'divider__line--spacing-top': spacingTop,
    'divider__line--spacing-top-large': spacingTopLarge,
    'divider__line--spacing-bottom': spacingBottom,
    'divider__line--spacing-bottom-large': spacingBottomLarge }"></div>
</template>

<script lang="ts">

import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';

@Component
export default class DividerComponent extends Vue {
    @Prop({ default: false })
    public spacingTop!: boolean;

    @Prop({ default: false })
    public spacingTopLarge!: boolean;

    @Prop({ default: false })
    public spacingBottom!: boolean;

    @Prop({ default: false })
    public spacingBottomLarge!: boolean;
}
</script>
